import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'font-awesome/css/font-awesome.min.css';
import { OverlayTrigger, Tooltip, Dropdown } from 'react-bootstrap';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

const FloatingMenu = ({ floatingButtons, onClick }) => {
  return (
    <div style={{ position: 'sticky', zIndex: '10', bottom: '10px', marginTop: '20px', userSelect: 'none' }} className='floating-menu-in'>
      {floatingButtons.map((value, index) => (
        <OverlayTrigger
          key={`float-top-${index}`}
          placement='top'
          overlay={
            <Tooltip id={`tooltip-top-${value.id}`} className='custom-tooltip'>
              {value.tooltip}
            </Tooltip>
          }>
          <button type="button" className={(value.name =='Assignment Settings' && value.isEnabled) ? 'text-castleRed':''} key={index} id={`floating-menu-${value.id}`} disabled={value.disabled} onClick={()=> onClick(value.id)}>
            {value.icon}
            {value.name}
          </button>
        </OverlayTrigger>
      ))}

      <Dropdown>
        <Dropdown.Toggle>
          <FontAwesomeIcon icon={faEllipsis} />More</Dropdown.Toggle>
        <Dropdown.Menu>
          {floatingButtons.map((value, index) => (
            <Dropdown.Item key={`float-menu-${index}`} disabled={value.disabled} onClick={() => value.onClick}>
              {value.icon} {value.name}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

FloatingMenu.propTypes = {
  floatingButtons: PropTypes.array.isRequired,
  onClick: PropTypes.func
};

FloatingMenu.defaultProps = {
  floatingButtons: []
};

export default FloatingMenu;
